import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FeaturesDetailsOverlayTypeEnum } from 'src/app/+installations/installation/installation-overlay.model';

import { FeaturesContainerComponent } from '@components';

@Component({
  selector: 'app-device-features-container',
  templateUrl: './device-features-container.component.html',
  styleUrls: ['./device-features-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceFeaturesContainerComponent extends FeaturesContainerComponent {
  @Input() deviceSelectId = '1';

  protected openOverlay(overlayType: FeaturesDetailsOverlayTypeEnum): void {
    this.installationService.setSelectedDeviceWithoutFetchingFeautures(this.deviceSelectId);

    super.openOverlay(overlayType);
  }
}
